var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6_2",
    transform: "scale(0.0322581)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6_2",
    width: 31,
    height: 31,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAYAAAAfrhY5AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALzSURBVHgB7VZNaBNREJ55u40h0krSYn92U9GkrakWqQfB/0pP/uClomCvXtqDBw+CP1AUvAiC1oMXQdGDitCDiAjWvxZR8AfFQym1iW2TlkBRMf60SfaNs2lTu7aNm7RCwXwh7O68N/PNzJs37wHk8b8BYYHgKy1dLoTjNCA1EEIQgY73RSJv4V+T11VWun8Y1MXG1k4JCRIEuKN/ePAZ2CH3adoJBGyErJ3CYtMHIvgIREcQoQkQm1nWw15Ef/uDnf2RoTPpb9VignA3K22EHIFIoTEB95eQKOS0m+QBlgamxoHMoGYnT8SVpgLVqIYsIRGKBcItZm9wAnRxjGtMORG1o4SOCceQVIfSZ3EWFgbC5/XuR4OuM8tkQHRbj4QPPgFIzqW0YNVuQtd1zSVxqwE4lKnQFgVsR+73eIrA5WohwpVcto/V+M97vaOjMZgHbJFzOj1Owhf8WpWWEeK1b4nx1mg0+h1yhIW8WqtslCS3zJiEYgMB7eLXIG+WDo68mRXL+fsSl3QU7IH9pTfc9e6mBZatJoHOMdO6GVr8S41LeTE4Ejnv1/TV7NIeFrXwfLALAmG229nJDZAnFcL18OdyYEq2lzNwqKpC1yTgZuT2ybMuZxE5hy67LWbtKNV4vRVJSY+49dZMWKEkp/9OfyS8LxVQjrCds0BJSXnc6WxiqjrO9MsP4fBVyNBAFj0UmAf8ZWW1bre7cVlhofIlFrO99mkIyAFtbW3Cr3mPgVDf8cFxQyV85avQL0CW7doyOVCyojzhTJ1qmY0Q1nPRneVKU1Dgaz7Ha1nBxafYYRTwfi61gjGlt2d0YCT9PX2rYcIhb7LhbWDLbTTr/EpSVVrVuDzKl4FTfGy2Z6r9hMN4zo9Ns5Fz24YHaPaav4DtF/O8Or4cBBzjyZ1SiO2TQ3xzgTnWnvOC1GnxH3KAX9N0Vn3K/1XTxJ8NqdaHRkIDdu3kVO2fYrGvnqWuhyBEES9TAffsbs7ageDwYAjyyCMDfgGvI/xMRTxH6wAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.27816ac346dceb000a27f0248a0c6854.svg";
export { ForwardRef as ReactComponent };